const SummaryPageRedirect = () => import(/* webpackChunkName: "section1" */ 'Features/summaryRedirect/components/SummaryPageRedirect');

const summaryRedirectRoute =  {
  name: 'summaryLink',
  path: '/s/:encodedId',
  component: SummaryPageRedirect,
  meta: {
    requiresAuth: false
  }
}

export const SummaryRedirectRoute = summaryRedirectRoute;